import { Button } from "@/components/elements/Button";
import { Input } from "@/components/elements/Input";
import { START_PAGE } from "@/constants/pagination";
import { EMPTY_STR } from "@/constants/string";
import { useCompanyFilterCache } from "@/features/company/provider/CompanyListFilterCacheProvider";
import { TPagination } from "@/types/api";
import { formatNumber } from "@/utils/number";
import { Stack, Typography } from "@mui/material";
import { ChangeEvent, FC, KeyboardEvent, useState } from "react";

type TCompanyListTopProps = {
  pagination?: TPagination;
};

export const CompanyListTop: FC<TCompanyListTopProps> = ({ pagination }) => {
  const totalText = pagination ? formatNumber(pagination.total) : EMPTY_STR.TEXT;
  const displayedText = pagination ? formatNumber((pagination.page - 1) * pagination.perPage + pagination.count) : EMPTY_STR.TEXT;

  const { companyFilterCache, setCompanyFilterCache } = useCompanyFilterCache();
  const [inputValue, setInputValue] = useState(companyFilterCache?.keyword || "");

  const applySearch = (value: string) => {
    setCompanyFilterCache({ ...companyFilterCache, keyword: value.trim() || undefined, page: START_PAGE });
  };

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setInputValue(value);
    if (value === "") applySearch("");
  };

  const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") applySearch((e.target as HTMLInputElement).value);
  };

  return (
    <Stack direction="row" justifyContent="space-between" alignItems="flex-end">
      <Stack direction="row" gap={2} alignItems="flex-end">
        <Typography variant="body14" py={1}>
          {`全 ${totalText} 件中 ${displayedText} 件を表示`}
        </Typography>

        <Stack>
          <Typography variant="cap12">検索(企業名/企業ID)</Typography>
          <Stack direction="row" gap={1} alignItems="center">
            <Input
              nonControl
              value={inputValue}
              onChange={handleChange}
              onKeyDown={handleKeyDown}
              placeholder="入力してください"
              size="md"
              sx={{ width: 280 }}
            />
            <Button size="sm" variant="ghost" onClick={() => applySearch(inputValue)}>
              検索
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
